import { useLayoutEffect } from 'react';
import mixpanel from 'mixpanel-browser';

import useFeature from './useFeature';
import useViewer from './useViewer';

import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export function useMixpanel(): typeof mixpanel | undefined {
	const workspace = useWorkspace();

	const enabled = useFeature('2021.analytics');
	const user = useViewer();

	if (workspace.id === 'try' || location.pathname === '/try') {
		return mixpanel;
	}

	return enabled && user?.allowsUsageStatistics ? mixpanel : undefined;
}

export function useMixpanelIdentify(id?: string, props?: Record<string, string>) {
	const mixpanel = useMixpanel();

	useLayoutEffect(() => {
		if (id) {
			mixpanel?.identify(id);

			for (const key in props ?? {}) {
				mixpanel?.people.set(key, props?.[key]);
			}
		}
	}, [id, !!mixpanel, JSON.stringify(props ?? {})]);
}

export function useMixpanelPeople(people?: Record<string, string>) {
	const mixpanel = useMixpanel();

	useLayoutEffect(() => {
		if (people) {
			mixpanel?.people.set(people);
		}
	}, [JSON.stringify(people), !!mixpanel]);
}

export function useMixpanelTrack(name: string | undefined) {
	const mixpanel = useMixpanel();

	useLayoutEffect(() => {
		if (name) {
			mixpanel?.track(name);
		}
	}, [name, !!mixpanel]);
}
